/* eslint-disable @typescript-eslint/no-empty-function */

import { createContext, type ReactNode } from 'react';
import { useToggle } from '../../../disclosure/hooks/useToggle/useToggle';

import { PhotoInstructionsDrawer } from '../PhotoInstructionsDrawer/PhotoInstructionsDrawer';

interface Context {
  open: boolean;
  handleClose: () => void;
  handleOpen: () => void;
}

export const PhotoInstructionsContext = createContext<Context>({
  handleClose: () => {},
  handleOpen: () => {},
  open: false,
});

const PhotoInstructionsProvider = ({
  children,
  example,
  frontFace,
  treeRing,
}: {
  children: ReactNode;
  example: string;
  frontFace: string;
  treeRing: string;
}) => {
  const { close: onClose, open: onOpen, isOpen: open } = useToggle();

  return (
    <PhotoInstructionsContext.Provider value={{ handleClose: onClose, handleOpen: onOpen, open }}>
      {children}
      <PhotoInstructionsDrawer
        example={example}
        frontFace={frontFace}
        treeRing={treeRing}
        open={open}
        handleClose={onClose}
      />
    </PhotoInstructionsContext.Provider>
  );
};

export { PhotoInstructionsProvider };
